import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import {
  selectActiveVenue,
  selectSchedulesStartDate,
  selectUserIsLoaded,
  selectUserPermissions,
} from 'selectors/general';
import { selectIsDesktop } from 'selectors/ui';

import VenueSchedulesContext from '../Contexts/VenueSchedulesContext';
import ScheduleList from '../ScheduleList/ScheduleList';
import { setSelectedSchedule, updateStartDate } from '../YieldManagement.saga';
import ScheduleListV2ItemContainer from './ScheduleListV2ItemContainer';

function mapStateToProps(state, ownProps) {
  const { venueId } = ownProps;
  const startDate = selectSchedulesStartDate(state);
  const { timezone } = selectActiveVenue(state);

  return {
    ...ownProps,
    ListItemComponent: ScheduleListV2ItemContainer,
    isDesktop: selectIsDesktop(state),
    isUserLoaded: selectUserIsLoaded(state),
    permissions: selectUserPermissions(state),
    showListHeader: false,
    startDate,
    venueId,
    venueTimezone: timezone,
  };
}

const mapDispatchToProps = {
  setSelectedSchedule,
  updateStartDate,
};

function ScheduleListV2(props) {
  const { isLoadingMore, schedules } = useContext(VenueSchedulesContext) || {};

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [isLoadingMore, schedules]);

  return <ScheduleList {...props} />;
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleListV2);
